import { useLanguage } from '../contexts/LanguageContext'

export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage()
  return <div className="language-switcher" aria-label="Language">
    <button className={language === 'pl' ? 'active' : ''} onClick={() => setLanguage('pl')} type="button">PL</button>
    <button className={language === 'ru' ? 'active' : ''} onClick={() => setLanguage('ru')} type="button">RU</button>
  </div>
}
